/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum GetPresenceResult {
  Error = 0,
  Success = 1,
}
